import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import Tag from '~shared/ui/Tag';
import uniqueId from 'lodash/uniqueId';
import isEmpty from 'lodash/isEmpty';
import { useTranslation } from 'react-i18next';
import {
    BB_BETFEED_FILTER_TYPE_SPORTS,
    BB_BETFEED_FILTER_TYPE_EVENT_STATUS,
    BB_BETFEED_FILTER_TYPE_BET_TYPE,
    BB_BETFEED_FILTER_BET_TYPES_DEFAULT,
    BB_BETFEED_FILTER_BOX_LABEL_BLOCK,
} from '../../constants';

const parseSports = (sports) => {
    return Object.keys(sports).map((key => {
        const { name } = sports[key];

        return { id: key, name, action: key, type:  BB_BETFEED_FILTER_TYPE_SPORTS.id};
    }));
};

const parseBetType = (obj, type) => {
    const { id } = obj;
    if(id === BB_BETFEED_FILTER_BET_TYPES_DEFAULT.id){

        return [];
    }

    return [{...obj, action: BB_BETFEED_FILTER_BET_TYPES_DEFAULT.id, type }];
};

const createTagArray = (selected) => {
    const { sports, betType, eventStatus } = selected;

    return [
        ...parseSports(sports),
        ...parseBetType(betType, BB_BETFEED_FILTER_TYPE_BET_TYPE.id),
        ...parseBetType(eventStatus, BB_BETFEED_FILTER_TYPE_EVENT_STATUS.id),
    ];
};

const LabelContainer = ({selected, toggleFilter}) => {
    const [t] = useTranslation();
    const selectedArray = createTagArray(selected);
    const handleCloseTag = useCallback((type, action) => () => {
        toggleFilter(type, action);
    }, [toggleFilter]);

    return (
        !isEmpty(selectedArray) &&
            <div className={BB_BETFEED_FILTER_BOX_LABEL_BLOCK}>
                {selectedArray.map((({id, name, type, action}) => {
                    return (
                        <Tag
                            key={uniqueId(id)}
                            onClose={handleCloseTag(type, action)}
                        >
                            {t(name)}
                        </Tag>
                    );
                } ))}
            </div>
    );
};

LabelContainer.propTypes = {
    selected: PropTypes.shape({
        betType: PropTypes.instanceOf(Object),
        eventStatus: PropTypes.instanceOf(Object),
        sports: PropTypes.instanceOf(Object),
        sortBy: PropTypes.instanceOf(Object),
    }),
    toogleFilter: PropTypes.func,
};

LabelContainer.defaultProps = {
    selected: {
        sports: {},
        betType: BB_BETFEED_FILTER_BET_TYPES_DEFAULT,
        eventStatus: BB_BETFEED_FILTER_BET_TYPES_DEFAULT,
    },
    toogleFilter: Function.prototype,
};


export default LabelContainer;
